import React from 'react';
import { AlertTriangle, MessageCircle, Star } from 'lucide-react';
import { ESTADOS_SOLICITUD, formatFecha, textoBeneficio } from '../bodasUtils';

const CLASE_ESTADO = { nuevo: 'bg-sky-100 text-sky-800', contactado: 'bg-amber-100 text-amber-800', convertido: 'bg-emerald-100 text-emerald-800', descartado: 'bg-slate-200 text-slate-600' };
const etiquetaEstado = (v) => ESTADOS_SOLICITUD.find(e => e.valor === v)?.etiqueta || v;
const waContacto = (s) => `https://wa.me/${`${s.indicativo || ''}${s.telefono || ''}`.replace(/\D/g, '')}`;
const textoBeneficioSolicitud = (s) => (s.no_aplica ? 'No aplica' : s.origen === 'referido' ? `${s.beneficio?.valor}% de descuento` : textoBeneficio(s.beneficio?.tipo, s.beneficio?.valor) || '-');

const Origen = ({ s }) => s.origen === 'boda'
  ? <><span className="font-medium text-slate-700">Boda {s.boda_pareja}</span>{s.cliente_nombre && <span className="block text-xs text-slate-500">Novio/a: {s.cliente_nombre}</span>}</>
  : <><span className="font-medium text-slate-700">Referido por {s.cliente_nombre}</span>{s.cliente_id_publico && <span className="block text-xs text-slate-500">{s.cliente_id_publico}</span>}</>;

const Seguimiento = ({ s }) => (
  <div className="space-y-1 text-xs">
    {s.no_aplica && (
      <p className="flex items-start gap-1 rounded-lg bg-amber-50 px-2 py-1 font-medium text-amber-900" data-testid={`solicitud-no-aplica-${s.id}`}>
        <AlertTriangle className="mt-0.5 h-3 w-3 shrink-0" />No aplica: {s.no_aplica.texto}
      </p>
    )}
    <p className="text-slate-600">{s.cotizacion_numero ? <>Cotización <strong>{s.cotizacion_numero}</strong></> : 'Sin cotización aún'}</p>
    {s.venta_numero && <p className="text-slate-600">Venta <strong>{s.venta_numero}</strong></p>}
    {s.puntos_otorgados > 0 && (
      <p className="inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 font-medium text-amber-900" data-testid={`solicitud-puntos-${s.id}`}>
        <Star className="h-3 w-3" fill="currentColor" />+{s.puntos_otorgados} pts al referente
      </p>
    )}
  </div>
);

const Contacto = ({ s, sufijo }) => (
  <>
    <p className="font-medium text-slate-800">{s.nombre}</p>
    <p className="break-all text-xs text-slate-500">{s.correo}</p>
    <a href={waContacto(s)} target="_blank" rel="noopener noreferrer" className="mt-1 inline-flex items-center gap-1 text-xs font-medium text-emerald-700 hover:underline" data-testid={`solicitud-whatsapp${sufijo}-${s.id}`}>
      <MessageCircle className="h-3.5 w-3.5" />{s.indicativo} {s.telefono}{s.consentimiento_whatsapp ? '' : ' (sin autorización de mensajes)'}
    </a>
  </>
);

const EstadoControl = ({ s, gestiona, onEstado, sufijo }) => (gestiona ? (
  <select value={s.estado} onChange={e => onEstado(s.id, e.target.value)} className="rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-sm" data-testid={`solicitud-estado${sufijo}-${s.id}`}>
    {ESTADOS_SOLICITUD.map(e => <option key={e.valor} value={e.valor}>{e.etiqueta}</option>)}
  </select>
) : <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${CLASE_ESTADO[s.estado]}`}>{etiquetaEstado(s.estado)}</span>);

export const FilaSolicitud = ({ s, gestiona, onEstado }) => (
  <tr className="align-top" data-testid={`solicitud-fila-${s.id}`}>
    <td className="whitespace-nowrap px-4 py-3 text-slate-500">{formatFecha(s.created_at)}</td>
    <td className="px-4 py-3"><Contacto s={s} sufijo="" /></td>
    <td className="px-4 py-3"><Origen s={s} /></td>
    <td className="whitespace-nowrap px-4 py-3 font-medium text-slate-700">{textoBeneficioSolicitud(s)}</td>
    <td className="px-4 py-3"><Seguimiento s={s} /></td>
    <td className="px-4 py-3"><EstadoControl s={s} gestiona={gestiona} onEstado={onEstado} sufijo="" /></td>
  </tr>
);

export const TarjetaSolicitud = ({ s, gestiona, onEstado }) => (
  <li className="space-y-3 p-4" data-testid={`solicitud-tarjeta-${s.id}`}>
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0"><Contacto s={s} sufijo="-movil" /></div>
      <span className="shrink-0 text-xs text-slate-500">{formatFecha(s.created_at)}</span>
    </div>
    <div className="text-sm"><Origen s={s} /></div>
    <div className="flex flex-wrap items-center justify-between gap-2">
      <span className="text-sm font-medium text-slate-700">{textoBeneficioSolicitud(s)}</span>
      <EstadoControl s={s} gestiona={gestiona} onEstado={onEstado} sufijo="-movil" />
    </div>
    <Seguimiento s={s} />
  </li>
);
